<script setup>
import "@/assets/main.css";

</script>
<template>
    <div class="relative w-full flex flex-col">
        <div class="flex relative h-fit justify-end pb-20">
            <div class="main-content relative z-20 flex flex-col justify-center text-center sm:w-[60%] md:w-full  mx-5">
                <div class="ayatWeda flex flex-col mx-5 text-center text-alt-dark">
                    <p>
                        Merupakan suatu kehormatan dan kebahagiaan kami apabila Bapak/Ibu/Saudara/i berkenan hadir untuk
                        menyaksikan dan memberikan doa
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style></style>
